import React, { useMemo } from 'react';
import PropTypes from 'prop-types';

import { constants, getMaintenanceByMode } from '@atlas/core';
import { Maintenance } from '@atlas/ui';

import HeaderLogoItem from 'components/Layout/Header/HeaderLogoItem';
import { LocalConfig } from 'src/common/utils';

const {
  MAINTENANCE_MODE: { GLOBAL },
} = constants;

const GlobalMaintenanceContainer = ({ children }) => {
  const projectId = LocalConfig.get('projectId');
  const maintenance = useMemo(() => getMaintenanceByMode(GLOBAL, projectId), [projectId]);

  if (maintenance) {
    return <Maintenance endAt={maintenance.end_at} logo={<HeaderLogoItem />} type={GLOBAL} />;
  }

  return children;
};

GlobalMaintenanceContainer.propTypes = {
  children: PropTypes.node,
};

export default GlobalMaintenanceContainer;
